import { atom } from 'jotai';
import { $CurrentArticleId } from '@article/shared/atoms/current-article-id';
import { $ArticleDetail, $UserDetail } from 'shared/atoms';
import { ArticleDetailUtil, IUserDetail, UserDetailUtil } from 'shared/models';

export const $CurrentArticleAuthor = atom((get) => {
  const currentArticleId = get($CurrentArticleId);
  const article = get($ArticleDetail(currentArticleId));
  if (!ArticleDetailUtil.isArticleAvailable(article)) {
    return null;
  }

  const {
    author: { userId },
  } = article;

  return get($UserDetail(userId));
});

export const $CurrentAvailableArticleAuthorOrNull = atom<Promise<IUserDetail | null>>(async (get) => {
  const author = await get($CurrentArticleAuthor);

  if (!author || !UserDetailUtil.isUserAvailable(author)) {
    return null;
  }

  return author;
});
